export const BORROWER_MODEL_KEYS = {
  firstName: "firstName",
  lastName: "lastName",
  emailAddress: "emailAddress",
  phone: "phone",
  company: "company",
  cashLiquidity: "cashLiquidity",
  referralSource: "referralSource",
  estimatedFICO: "estimatedFICO",

  // NEW FIELDS NOT YET ADDED TO OFFICIAL MODEL
  smsOptIn: "smsOptIn",
  additionalLoanDetails: "additionalLoanDetails",
  similar_projects_last_3_years: "similar_projects_last_3_years",
};
